import React, { useEffect, useState } from 'react';
import { DatePicker, Select } from 'antd';
import debounce from 'lodash/debounce';
import moment from 'moment';
import Axios from 'axios';
import { useSelector } from 'react-redux';
import swal from 'sweetalert';
import { Dropdown, Spinner } from 'react-bootstrap';
import TableComponent from '../../../../_metronic/table/TableComponent';
import DetailsModal from '../../orders/orders-historyb2c/DetailsModal';
import { CSVLink } from 'react-csv';

const { Option } = Select;
const { RangePicker } = DatePicker;

function CustomerSaleReport() {
  const {
    user: { accessToken, refreshToken },
  } = useSelector((state) => state.auth);

  const startOfMonth = moment().startOf('month');
  const endOfMonth = moment().endOf('month');
  const formatStart = startOfMonth.format('YYYY-MM-DD');
  const formatEnd = endOfMonth.format('YYYY-MM-DD');
  console.log();

  const [loading, setLoading] = useState(false);
  const [validationDate, setValidationDate] = useState(false);
  const [start_date_range, setstart_date_range] = useState(formatStart);
  const [end_date_range, setend_date_range] = useState(formatEnd);

  const [orderData, setOrderData] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState('');

  const [headers, setHeaders] = useState([]);
  const [customerwiseproductReport, setCustomerwiseproductReport] = useState(
    []
  );
  const [headers2, setHeaders2] = useState([]);
  const [itemwiseproductReport, setItemwiseproductReport] = useState([]);

  const getCustomerwiseproductReport = async () => {
    const { data } = await Axios.get(
      `${process.env.REACT_APP_API_URL}/report/getCustomerSummaryReport/B2C/${start_date_range}/${end_date_range}`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
          refreshToken: refreshToken,
        },
      }
    );

    if (!data.error) {
      setCustomerwiseproductReport(data.data);
      const singleData = data.data[0];
      const makeHeader = [];
      for (let key in singleData) {
        makeHeader.push({ label: key, key: key });
      }
      setHeaders(makeHeader);
    } else {
      swal({
        title: 'Something went wrong',
        icon: 'error',
      });
    }
  };
  const getItemwiseproductReport = async () => {
    const { data } = await Axios.get(
      `${process.env.REACT_APP_API_URL}/report/getCustomerItemDetailsReport/B2C/${start_date_range}/${end_date_range}`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
          refreshToken: refreshToken,
        },
      }
    );

    if (!data.error) {
      setItemwiseproductReport(data.data);
      const singleData = data.data[0];
      const makeHeader = [];
      for (let key in singleData) {
        makeHeader.push({ label: key, key: key });
      }
      setHeaders2(makeHeader);
    } else {
      swal({
        title: 'Something went wrong',
        icon: 'error',
      });
    }
  };

  useEffect(() => {
    getCustomerwiseproductReport();
    getItemwiseproductReport();
  }, []);

  useEffect(() => {
    if (end_date_range || start_date_range) {
      getCustomerwiseproductReport();
      getItemwiseproductReport();
    }
  }, [end_date_range, start_date_range]);

  const data = React.useMemo(() => orderData, [orderData]);
  const columns = React.useMemo(
    () => [
      {
        Header: '#',
        accessor: (row, index) => (
          <div className="d-flex align-items-center pl-4">
            <div>
              <h4 className="text-dark-75 font-weight-bolder mb-1 font-size-sm">
                {index + 1}
              </h4>
            </div>
          </div>
        ),
        minWidth: 50,
        width: 50,
      },
      {
        Header: 'customer name',
        accessor: 'customer_name',
        paddingLeft: '0px',
      },
      {
        Header: 'user phone',
        accessor: 'user_phone',
        paddingLeft: '0px',
      },
      {
        Header: 'grand total',
        accessor: 'grand_total',
        paddingLeft: '0px',
      },
      {
        Header: 'discount',
        accessor: 'discount',
        paddingLeft: '0px',
      },
      {
        Header: 'vat',
        accessor: 'vat',
        paddingLeft: '0px',
      },
      {
        Header: 'redeem point',
        accessor: 'redeem_point',
        paddingLeft: '0px',
      },
      {
        Header: 'Earn point',
        accessor: 'earn_point',
        paddingLeft: '0px',
      },
      {
        Header: 'Action',
        paddingLeft: '0px',
        width: 150,
        minWidth: 150,
        Cell: ({ row }) => (
          <button
            className="btn btn-sm btn-primary"
            onClick={() => setSelectedOrder(row.original)}
          >
            <i className="fas fa-eye p-0 m-0" />
          </button>
        ),
      },
    ],
    [orderData]
  );

  const handleDateRange = (dateArr, date) => {
    const dates = [...dateArr];
    setstart_date_range(dates[0]);
    setend_date_range(dates[1]);
  };

  const handleSearch = async () => {
    const searchData = {
      start_date: start_date_range,
      end_date: end_date_range,
      customer_id: Number(value.id),
    };

    setLoading(true);
    try {
      const { data } = await Axios.post(
        `${process.env.REACT_APP_API_URL}/report/customerOrderHistory`,
        searchData,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
            refreshToken: refreshToken,
          },
        }
      );
      if (data.data.length === 0) {
        swal({
          title: 'No Data Found!',
          icon: 'info',
        });
      }
      if (!data.error) {
        setOrderData(data.data);
        setLoading(false);
      } else {
        if (data.data.length === 0) {
          swal({
            title: 'No Data Found!',
            icon: 'info',
          });
        }
        setLoading(false);
        setOrderData([]);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  function DebounceSelect({ fetchOptions, debounceTimeout = 800, ...props }) {
    const [fetching, setFetching] = React.useState(false);
    const [options, setOptions] = React.useState([]);
    const fetchRef = React.useRef(0);
    const debounceFetcher = React.useMemo(() => {
      const loadOptions = (value) => {
        fetchRef.current += 1;
        const fetchId = fetchRef.current;
        setOptions([]);
        setFetching(true);
        fetchOptions(value).then((newOptions) => {
          if (fetchId !== fetchRef.current) {
            // for fetch callback order
            return;
          }

          setOptions(newOptions);
          setFetching(false);
        });
      };

      return debounce(loadOptions, debounceTimeout);
    }, [fetchOptions, debounceTimeout]);
    return (
      <Select
        showSearch
        filterOption={false}
        onSearch={debounceFetcher}
        defaultActiveFirstOption={false}
        {...props}
        options={options}
      />
    );
  } // Usage of DebounceSelect

  async function fetchUserList(username) {
    const { data } = await Axios.post(
      `${process.env.REACT_APP_API_URL}/customer/getCustomerNameLikeWise`,
      { name: username },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
          refreshToken: refreshToken,
        },
      }
    );

    return data.data.map((user) => ({
      label: user.name_phone,
      value: JSON.stringify(user),
    }));
  }

  const [value, setValue] = React.useState({ id: null, name_phone: null });
  return (
    <div className="card">
      <div className="card-header border-0 d-flex justify-content-between pb-0">
        <h3 className="card-title mb-0">Customer Sales Report</h3>

        <Dropdown>
          <Dropdown.Toggle variant="primary" id="dropdown-basic">
            Download Report
          </Dropdown.Toggle>

          <Dropdown.Menu className="p-3">
            <CSVLink
              className="btn btn-secondary"
              data={customerwiseproductReport}
              headers={headers}
              filename="Customerwise Summary Report"
            >
              Customer Summary
            </CSVLink>
            <CSVLink
              className="btn btn-secondary mt-2 w-100"
              data={itemwiseproductReport}
              headers={headers2}
              filename="Customer Item wise Report"
            >
              Item wise
            </CSVLink>
          </Dropdown.Menu>
        </Dropdown>
      </div>

      <div className="card-body">
        <div className="row mb-5">
          <div
            className="col-md-3"
            style={{ display: 'flex', flexDirection: 'column' }}
          >
            <label htmlFor="">Select Date</label>
            <RangePicker
              defaultValue={[startOfMonth, endOfMonth]}
              format={'YYYY-MM-DD'}
              onChange={(date, dateString) => handleDateRange(dateString, date)}
            />
            {validationDate ? (
              <p className="is_required">Please select start date first</p>
            ) : null}
          </div>

          <div className="col-md-4">
            <label htmlFor="">Search & Select User</label>
            <DebounceSelect
              value={value.name_phone}
              placeholder="Select users"
              fetchOptions={fetchUserList}
              onChange={(newValue) => {
                setValue(JSON.parse(newValue));
              }}
              style={{
                width: '100%',
              }}
            />
          </div>

          <div className="col-md-4 align-self-center text-left">
            <button
              className="btn btn-primary w-50"
              onClick={() => handleSearch()}
              disabled={loading}
            >
              Search{' '}
              {loading && (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
            </button>
          </div>
        </div>
      </div>
      {orderData.length ? (
        <>
          <TableComponent
            data={data}
            columns={columns}
            lists={orderData}
            title="Order Data"
            hideAddButton={true}
          />
        </>
      ) : (
        ''
      )}

      {selectedOrder && (
        <DetailsModal
          setShowDetails={setSelectedOrder}
          showDetails={selectedOrder}
          url="orders-historyb2c"
          selectedUser={selectedOrder}
          setSelectedUser={setSelectedOrder}
          accessToken={accessToken}
          refreshToken={refreshToken}
        />
      )}
    </div>
  );
}

export default CustomerSaleReport;
